export default function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/jsutils/invariant.mjs
// module id = 2823
// module chunks = 0